import { useState } from "react";

import { LoadingButton } from "@mui/lab";

import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { EXPORT_FORMATS, EXPORT_FORMATS_LIST } from "../types/export";

type ExportDropdownProps = {
  supportedFormats: EXPORT_FORMATS[];
  onExport: (format: EXPORT_FORMATS) => void;
  loading?: boolean;
};

export default function ExportDropdown({
  supportedFormats,
  onExport,
  loading = false,
}: ExportDropdownProps) {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(menuAnchorEl);

  const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleExportClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
      <LoadingButton
        loading={loading}
        startIcon={<FileDownloadIcon />}
        aria-controls={open ? "export-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-label="export as"
        aria-haspopup="menu"
        onClick={handleExportClick}
        variant="outlined"
      >
        Eksportēt
      </LoadingButton>
      <Menu
        id="export-menu"
        anchorEl={menuAnchorEl}
        open={open}
        onClose={handleExportClose}
      >
        {supportedFormats.map((format) => (
          <MenuItem
            key={format}
            onClick={() => {
              onExport(format);
              handleExportClose();
            }}
          >
            <ListItemIcon>{EXPORT_FORMATS_LIST[format].icon}</ListItemIcon>
            <ListItemText primary={EXPORT_FORMATS_LIST[format].label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
